module.exports = __webpack_public_path__ + "img/santo.51151b82.png";